// Types
export const TOGGLE_VIEW_LISTS_ALL = 'TOGGLE_VIEW_LISTS_ALL';
export const TOGGLE_VIEW_LISTS_STARRED = 'TOGGLE_VIEW_LISTS_STARRED';
export const TOGGLE_MSG_STARRED_MAXIMUM = 'TOGGLE_MSG_STARRED_MAXIMUM';

export const toggleViewListsToAll = newView => {
	return {
		type: TOGGLE_VIEW_LISTS_ALL,
		newView: newView
	};
};

export const toggleViewListsToStarred = newView => {
	return {
		type: TOGGLE_VIEW_LISTS_STARRED,
		newView: newView
	};
};

export const toggleMsgStarredMaximum = (newStatus) => {
	return {
        type: TOGGLE_MSG_STARRED_MAXIMUM,
        newStatus: newStatus
	};
};



// WEBPACK FOOTER //
// ./src/actions/actions_view.js